module.exports = __webpack_public_path__ + "assets/img/baja-blitz.100d5795.png";